import useSWR from 'swr';
import { useRouter } from 'next/router';
import config from '@packages/config';
import { bucketFetcher, getEndpoint } from '../../utils';
import type { CmsData } from '../../../interfaces/webapp_json';

export const useFooterData = () => {
  const { locale: language, defaultLocale: defaultLanguage } = useRouter();
  const finalLanguage = language || defaultLanguage || 'de';
  const footerCmsCacheKey = `footer-${finalLanguage}`;
  const { footer } = config;
  const footerCmsEndpoint = getEndpoint(footer.apiEndpoints.bucket, 'footer', finalLanguage);
  const { data } = useSWR<CmsData>(footerCmsCacheKey, bucketFetcher<CmsData>(footerCmsEndpoint), {
    // prevent fetching newer data (https://swr.vercel.app/docs/revalidation#disable-automatic-revalidations)
    // but revalidate if stale to make language switch work
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    revalidateOnMount: false,
  });
  return data;
};
